import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-view",
    templateUrl: "./view.component.html",
    styleUrls: ["./view.component.scss"],
    standalone: false
})
export class ViewDialogComponent implements OnInit, OnDestroy {
  constructor(
    public dialogRef: MatDialogRef<ViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.id = data.id;
      this.showMessage = data.showMessage;
      this.canvasType = data.canvasType;
    }
  }

  id!: number;
  showMessage!: boolean;
  canvasType?: string;

  onNoClick(): void {
    this.dialogRef.close();
  }
  onConfirmClick(): void {
    this.dialogRef.close({
      save: false,
    });
  }
  saveAndView(): void {
    this.dialogRef.close({
      result: true,
      save: true,
    });
  }

  ngOnInit(): void {}
  ngOnDestroy(): void {}
}
